export default __webpack_public_path__ + "assets/ico_gamerules-8c799362.svg";